<template>
  <div
    v-if="shouldShow"
    class="text-widget"
    :style="style"
    @click="click($event)"
  >
    <div :class="['text', { 'ellipsis-wrap': widget.ellipsis } ]">
      {{ widget.text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextWidgetView',
  props: {
    widget: {
      type: Object,
    },
  },
  computed: {
    style() {
      return {
        left: this.widget.left === 'unset' ? this.widget.left : `${this.widget.left}px`,
        right: this.widget.right === 'unset' ? this.widget.right : `${this.widget.right}px`,
        top: `${this.widget.top}px`,
        height: `${this.widget.height}px`,
        width: `${this.widget.width}px`,
        zIndex: this.widget.zIndex,
        transform: `rotate(${this.widget.rotate}deg)`,
        background: this.widget.background,
        color: this.widget.color,
        fontSize: `${this.widget.fontSize}px`,
        justifyContent: this.widget.textAlign,
        textAlign: this.widget.textAlign,
        direction: this.widget.direction,
        alignItems: this.widget.verticalAlign,
        fontFamily: this.widget.fontFamily,
        lineHeight: `${this.widget.lineHeight}px`,
        borderRadius: `${this.widget.borderRadius}px`,
        padding: this.widget.padding,
        ...(this.widget.url ? { cursor: 'pointer' } : {}),
        ...(this.widget.actionEventName ? { cursor: 'pointer' } : {}),
        boxShadow: this.widget.boxShadow,
        border: this.widget.border,
        textShadow: this.widget.textShadow,
      };
    },
    shouldShow() {
      if (this.widget.shouldShow === undefined || this.widget.shouldShow === null) {
        return true;
      }
      return this.widget.shouldShow === 'true';
    },
  },
  methods: {
    click(e) {
      if (this.widget.url) {
        this.$emit('userInteraction', {
          eventName: 'StoryExternalLinkClicked',
          url: this.widget.url,
        });
        window.open(this.widget.url, '_blank');
      } else if (this.widget.actionEventName) {
        this.$emit('userInteraction', {
          eventName: this.widget.actionEventName,
        });

        e.stopPropagation();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-widget {
  position: absolute;
  display: flex;

  .text.ellipsis-wrap {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
